export default __webpack_public_path__ + "static/ballerz-26af3d391b0df2ca58a5d061e61b1959.png";